import PlusIcon from '@/assets/icons/plus.svg?react';
import { NoResults } from '@/components/elements/no-results/no-results.component';
import { T } from '@/components/i18n/message.i18n.component';
import Button from '@/components/ui/button/button.component';
import { Product } from '@/gql/graphql';
import { productPageMessages } from './products.messages';

type ProductsNoResultsProps = {
  loading: boolean;
  products?: Product[];
  search: string;
  onProductAdd: () => void;
};

export const ProductsNoResults = ({
  loading,
  products,
  search,
  onProductAdd: handleProductAdd,
}: ProductsNoResultsProps) => {
  if (loading) return null;
  if (products && products.length === 0 && !search) {
    return (
      <NoResults
        data-testid="product-page-no-results"
        message={<T {...productPageMessages.noResults} />}
        button={
          <Button data-testid="product-page-no-results-add-button" onClick={handleProductAdd} variant="secondary">
            <PlusIcon className="w-5" />
            <T {...productPageMessages.noResultsButton} />
          </Button>
        }
      />
    );
  }
  if (products && products.length === 0 && search) {
    return (
      <NoResults
        data-testid="product-page-search-no-results"
        message={<T {...productPageMessages.noProductsFound} />}
      />
    );
  }
};
